module.exports = "/_next/static/images/6701c802b22900f74ec7a15c6845bf35-holding-device-smile-2@1x.jpg";